﻿export async function DiagramExpandingSearch() {

    $('.js-header-search-input').on('focus', function () {
        $('.site-header-top').addClass('search-open');
    });

    $('.js-header-search-input').on('blur', function () {
        $('.site-header-top').removeClass('search-open');
    });
}